import { rowReorderEffects } from '../../../core/row-reorder/index.js';
import { rowSelectionEffects } from '../../../core/row-selection/index.js';
import { GanttBarDisplaySettings } from './bars/bar-display-settings.js';
import { GanttBarHoverTooltip } from './bars/bar-hover-tooltip.js';
import { GanttBarRenderer } from './bars/bar-renderer.js';
import { GanttDependencyOverlay } from './dependencies/dependency-overlay.js';
import { GanttDragTooltip } from './drag/drag-tooltip.js';
import { GanttEmptyDb } from './empty-states/gantt-empty-db.js';
import { GanttViewUI } from './gantt-view-ui-logic.js';
import { GanttSetupWizard } from './setup-wizard/gantt-setup-wizard.js';
import { GanttSwimlaneGroup } from './swimlanes/swimlane-group.js';
import { GanttSwimlaneHeader } from './swimlanes/swimlane-header.js';
import { GanttTimeAxisHeader } from './time-axis/time-axis-header.js';
import { GanttTodayIndicator } from './time-axis/today-indicator.js';
import { GanttZoomToolbar } from './time-axis/zoom-toolbar.js';
import { GanttValidationIndicator } from './validation-indicator.js';

export function pcEffects(): void {
  rowReorderEffects();
  rowSelectionEffects();
  customElements.define('dv-gantt-view-ui', GanttViewUI);
  customElements.define('dv-gantt-time-axis-header', GanttTimeAxisHeader);
  customElements.define('dv-gantt-today-indicator', GanttTodayIndicator);
  customElements.define('dv-gantt-zoom-toolbar', GanttZoomToolbar);
  customElements.define('dv-gantt-bar-renderer', GanttBarRenderer);
  customElements.define(
    'dv-gantt-bar-display-settings',
    GanttBarDisplaySettings
  );
  customElements.define('dv-gantt-bar-hover-tooltip', GanttBarHoverTooltip);
  customElements.define('dv-gantt-drag-tooltip', GanttDragTooltip);
  customElements.define('dv-gantt-dependency-overlay', GanttDependencyOverlay);
  customElements.define('dv-gantt-empty-db', GanttEmptyDb);
  customElements.define(
    'dv-gantt-validation-indicator',
    GanttValidationIndicator
  );
  customElements.define('dv-gantt-setup-wizard', GanttSetupWizard);
  customElements.define('dv-gantt-swimlane-header', GanttSwimlaneHeader);
  customElements.define('dv-gantt-swimlane-group', GanttSwimlaneGroup);
}
